import { dispatchAction } from '@ardoq/rxbeach';
import { imageDroppedOnComponentNode } from 'streams/components/ComponentActions';
import type { HandleImageDropCallback } from 'yfilesExtensions/view/modernized/types';

export const dispatchImageDrop: HandleImageDropCallback = (componentId, file) =>
  dispatchAction(imageDroppedOnComponentNode({ componentId, file }));
